import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import React, { Fragment } from 'react'
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import estilos from '../../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { getElementoSeccionByIdArea } from '../../../../../redux/DucksUnidadInspeccion/ElementoSeccionDuck';
import { getProcesoByIdArea } from '../../../../../redux/DucksUnidadInspeccion/ProcesosDuck';
import { insertFi25Procesos } from '../../../../../redux/DucksUnidadInspeccion/Fi25anexoProcesosDuck';
import { insertEquipoHistorial } from '../../../../../redux/DucksUnidadInspeccion/Fi25anexoEquipoHistorial';
import { insertDataElementoClienteHistorial } from '../../../../../redux/DucksUnidadInspeccion/DataElementoClienteHistorialDuck';
import { insertSuperficie } from '../../../../../redux/DucksUnidadInspeccion/SuperficieDuck';

import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function CoccionFormComponent(props) {

    const dispatch = useDispatch()

    const [isContext, setIsContext] = React.useState(false);

    const tipoequipo = useSelector(store => store.ElementoSeccion.ElementoSeccion);
    //const procesos = useSelector(store => store.Procesos.Proceso);

    const [procesos, setProcesos] = React.useState([]);

    const [equipoCoccion, setEquipoCoccion] = React.useState();
    const [procesosCoccion, setProcesosCoccion] = React.useState([]);

    const [initialValues, setInitialValues] = React.useState({
        piñas: '',
        jugos: '',
        equipoCoccion: equipoCoccion,
        procesosCoccion: procesosCoccion,
    })

    const [informacionFormikModal, setInformacionFormikModal] = React.useState(
        {
            tipo: '',
            cantidad: '',
            capacidad: '',
            descripcion: '',
            condicion: '',
        }
    );



    const [openModalNuevoEquipo, setOpenModalNuevoEquipo] = React.useState(false);

    const [editarEquipo, setEditarEquipo] = React.useState(true);

    useEffect(() => {

        const equipo = props.informe.fi_25_anexo[0].fi_25_anexo_equipo_historial.filter(e => e.elemento.elementosdeseccion[0].idseccion == 1)

        setEquipoCoccion(equipo)

        dispatch(getElementoSeccionByIdArea(1))
        dispatch(getProcesoByIdArea(1)).then((res) => {
            setProcesos(res.payload.data.data)
        })
    }, [])

    useEffect(() => {
        let sup = props.informe.fi_25_anexo[0].superficie.filter(s => s.idseccion == 1);
        setInitialValues({
            equipoCoccion: equipoCoccion,
            procesosCoccion: procesosCoccion,
            largo: sup[0].largo,
            ancho: sup[0].ancho,
            area: sup[0].area
        })
    }, [equipoCoccion, procesosCoccion])

    useEffect(() => {
        let aux = []
        props.informe.fi_25_anexo[0].fi_25_anexo_procesos.forEach((e) => {
            procesos.forEach(element => {
                if (element.idseccion == 1) {
                    if (e.idproceso == element.idproceso) {
                        if (!procesosCoccion.includes(element)) {
                            aux.push(e)
                        }
                    }
                }
            })
        })

        setProcesosCoccion(aux)

    }, [procesos])

    const handleModificar = () => {
        setEditarEquipo(!editarEquipo);
    }

    const handleOpenModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(true);
    }
    const handleCloseModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(false);
    }

    useEffect(() => {
        initialValues
    }, [initialValues])

    const handleNuevoEquipo = (valores) => {

        let equipoSeleccionado = tipoequipo.filter((t) => valores.tipo == t.idelemento)

        setEquipoCoccion([...equipoCoccion, {
            cantidad: valores.cantidad,
            capacidad: valores.capacidad,
            descripcion: valores.descripcion,
            condicion: valores.condicion,
            elemento: {
                idelemento: valores.tipo,
                tipoOtros: valores.tipoOtros,
                nombreelemento: equipoSeleccionado[0].elemento.nombreelemento
            },
            //idanexocliente: 1,
            //iddataelemntocliente: 1,
            //idseccion: 1,
            otro: null
        }])

        handleCloseModalNuevoEquipo();
    }

    const handleEliminarEquipo = (elemento) => {
        let nuevoEquipo = equipoCoccion.filter((equipo) => equipo !== elemento);
        setEquipoCoccion(nuevoEquipo);
    }

    const modalNuevoEquipo = () => {
        return (
            <div>
                <Modal
                    open={openModalNuevoEquipo}
                    onClose={handleCloseModalNuevoEquipo}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Nuevo Equipo
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={informacionFormikModal}
                                onSubmit={(valores) => {
                                    handleNuevoEquipo(valores)
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className='table-responsive'>
                                            <table className='table table-striped table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th>Tipo</th>
                                                        <th>Cantidad</th>
                                                        <th>Capacidad (ton)</th>
                                                        <th>Descripción y/o características</th>
                                                        <th width="120">Condición</th>
                                                        {//<th>Largo (m)</th>
                                                        }
                                                        {//<th>Ancho (m)</th>
                                                        }
                                                        {//<th>Área (m²)</th>
                                                        }
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="tipo"
                                                                name="tipo"
                                                                className="form-select"
                                                                multiple={false}
                                                                required
                                                            >
                                                                <option defaultValue>Seleccione Tipo de Equipo</option>
                                                                {tipoequipo.map((t, index) => (
                                                                    <option key={index} value={t.idelemento}>{t.elemento.nombreelemento}</option>
                                                                ))}
                                                            </Field>
                                                            {
                                                                props.values.tipo === "4" ?
                                                                    <div>
                                                                        <br />
                                                                        <label htmlFor='tipoOtros'>Tipo de equipo:</label>
                                                                        <Field
                                                                            type="text"
                                                                            id="tipoOtros"
                                                                            name="tipoOtros"
                                                                            className="form-control form-control-sm"
                                                                        />
                                                                    </div>
                                                                    : <div></div>
                                                            }
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name="cantidad" placeholder="Cantidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name="capacidad" placeholder="Capacidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name="descripcion" placeholder="Descripción" required /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name="condicion"
                                                                className="form-select"
                                                                multiple={false}
                                                                required

                                                            >
                                                                <option defaultValue>Seleccione Condición</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" onChange={handleObtenerLargo} value={superficie.largo} required /></td>
                                                        }
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" onChange={handleObtenerAncho} value={superficie.ancho} required /></td>
                                                        }
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={superficie.area} required /></td>
                                                        }
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button type='submit' className="btn btn-success">GUARDAR</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validate={(valores) => {

                }}

                onSubmit={(valores) => {




                }}
            >
                {({ values }) => (
                    <Form>
                        {/* <div className='row'>
                             <label className={`${estilos.labelUI_title} mb-2`}>COCCIÓN</label>
                        </div>
                        */}
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <label className={`${estilos.labelUI} mb-2`}>Superficie:</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-3 mb-3">
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="largo">Largo (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" required />
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="ancho">Ancho (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" required />
                            </div>

                            <div className="col-md-2 mb-3">
                                <label htmlFor="area">Área (m²)</label>
                                <Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={values.largo * values.ancho} required />
                            </div>
                        </div>
                        <hr />
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <div className='col-md-6 mb-3'>
                                <label className={`${estilos.labelUI} mb-2`}>La empresa realiza la cocción de:</label>
                            </div>
                            <div className="col-md-3 mb-3">
                                <label htmlFor='piñas'>
                                    <Field className="form-check-input" type="checkbox" name="piñas" id="piñas" />
                                    <br />
                                    <div className='text-white'> Cabezas o piñas de maguey</div>
                                </label>

                            </div>
                            <div className="col-md-3 mb-3">
                                <label htmlFor="jugos">
                                    <Field className="form-check-input" type="checkbox" name="jugos" id="jugos" />
                                    <br />
                                    <div className='text-white'> Jugos de agave</div>

                                </label>
                            </div>
                        </div>
                        <div className='table-responsive'>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Cantidad</th>
                                        <th>Capacidad (ton)</th>
                                        <th>Descripción y/o características</th>
                                        <th width="120">Condición</th>
                                        {//<th>Largo <br /> (m)</th>
                                        }
                                        {//<th>Ancho (m)</th>
                                        }
                                        {//<th>Área (m²)</th>
                                        }
                                        <th>Acciones</th>
                                        <th>Validar</th>
                                    </tr>
                                </thead>
                                <FieldArray
                                    name='equipoCoccion'
                                    render={arrayHelpers => (
                                        <tbody>
                                            {equipoCoccion &&
                                                equipoCoccion.map((equipo, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {equipo.elemento.nombreelemento}
                                                            <h6>{equipo.elemento.tipoOtros}</h6>
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name={`equipoCoccion.${index}.cantidad`} placeholder="Cantidad" required disabled={false} /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name={`equipoCoccion.${index}.capacidad`} placeholder="Capacidad" required disabled={false} /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name={`equipoCoccion.${index}.descripcion`} placeholder="Descripción" required disabled={false} /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name={`equipoCoccion.${index}.condicion`}
                                                                className="form-select"
                                                                multiple={false}
                                                                disabled={false}
                                                                required
                                                            >
                                                                <option defaultValue>Seleccione Condicion</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="largo" name={`equipoCoccion.${index}.largo`} placeholder="Largo" disabled={editarEquipo} required /></td>
                                                        }
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="ancho" name={`equipoCoccion.${index}.ancho`} placeholder="Ancho" disabled={editarEquipo} required /></td>
                                                        }
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="area" name={`equipoCoccion.${index}.area`} placeholder="Área" value={superficie.area} disabled={editarEquipo} required /></td>
                                                        }
                                                        <td><button type="button" className='btn btn-warning btn-sm' onClick={() => handleModificar()}>Modificar</button> <hr /> <button type="button" className='btn btn-danger btn-sm' onClick={() => handleEliminarEquipo(equipo)}>Eliminar</button></td>
                                                        <td><Field className="form-check-input" type="checkbox" name={`equipoCoccion.${index}.validar`} id="validar" /></td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    )}
                                />
                            </table>
                        </div>
                        <br />
                        <div style={{ textAlign: "center" }}>
                            <button type="button" className={`btn ${estilos.botonCircular}`} onClick={handleOpenModalNuevoEquipo}>+ </button> Añadir nuevo equipo
                        </div>
                        <br />
                        <div className='row'>
                            <label className={`${estilos.labelUI} mb-2`}>MÉTODO</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-4 mb-3">
                                <label htmlFor="">PROCESO</label>
                            </div>
                            <div className="col-md-8 mb-3">
                                <label htmlFor="">DESCRIPCIÓN</label>
                            </div>
                        </div>
                        <FieldArray
                            name='procesosCoccion'
                            render={arrayHelpers => (
                                <div>
                                    {procesosCoccion.map((p, index) => (
                                        <div key={index}>
                                            <div className='row'>
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor={`proceso.${index}`}>{p.procesos.descripcion}</label>
                                                </div>
                                                <div className="col-md-8 mb-3">
                                                    <Field type="text" className="form-control form-control-sm" id={`procesosCoccion.${index}`} name={`procesosCoccion.${index}.comentarios`} placeholder={p.procesos.descripcion} required />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        />

                        <div className="row mb-5">
                            <div className="col ">
                                <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit'>GUARDAR</button>
                            </div>

                        </div>


                    </Form>
                )}
            </Formik>

            <div>
                {modalNuevoEquipo()}
            </div>
        </Fragment>
    );
};


export default withRouter(CoccionFormComponent)
